import $ from 'jquery'
export default function ShowMore() {
  const moreElements = document.querySelectorAll('[data-more]');  
  moreElements.forEach((el) => {
    if (!el) return;
    const moreContent = el.querySelector('[data-more-content]');
    const btn = el.querySelector('[data-more-btn]');
    const btnAttrText = btn.dataset.moreBtn;
    const btnText = btn.innerText;
    let items = null;
    const oneYear = 12;
    let currentItemsCount = +moreContent.dataset.moreContent;
    let loadItemsCount = +btn.dataset.moreItemCount * oneYear;
    let state = false;
    if (moreContent.dataset.simplebar) {
      items = [...moreContent.querySelectorAll('.table__tr')];
    } else {
      items = [...moreContent.children];
    }

    const scrollToTop = () => {  setTimeout(
      () =>
      $('html, body').animate(
        {
          scrollTop: 0  
        },
        0
      ), 0)
    }

    const hideItems = () => {
      for (let i = currentItemsCount; i < items.length; i++) {
        items[i].classList.add('hide-more-items');
      }
      scrollToTop()
    };
    const showAllItems = () => {
      for (let i = 0; i < items.length; i++) {
        items[i].classList.remove('hide-more-items');
      }
    };

    /*Function For Step show*/
    const getRemainder = () => {
      if (currentItemsCount + loadItemsCount > items.length) {
        loadItemsCount = items.length - currentItemsCount;
      }
    };
    const resetToDefault = () => {
      currentItemsCount = +moreContent.dataset.moreContent;
      loadItemsCount = +btn.dataset.moreItemCount * oneYear;
      hideItems();
      state = false;
      btn.querySelector('.btn__inner').innerHTML = btnText;
    };
    const stepIncrements = () => {
      for (let i = currentItemsCount; i < currentItemsCount + loadItemsCount; i++) {
        items[i].classList.remove('hide-more-items');
      }
      currentItemsCount += loadItemsCount;
    };
    const completeAllItems = () => {
      if (currentItemsCount === items.length) {
        btn.querySelector('.btn__inner').innerHTML = btnAttrText;
        state = true;
      }
    };
    const showStepItems = () => {
      if (state) {
        resetToDefault();
      } else {
        getRemainder();
        stepIncrements();
      }
      completeAllItems();
    };
    /*Function For Step show*/

    btn.addEventListener('click', () => {
      if (btn.dataset.moreItemCount) {
        showStepItems();
      } else {
        if (state === false) {
          state = true;
          showAllItems();
          btn.querySelector('.btn__inner').innerHTML = btnAttrText;
        } else {
          state = false;
          hideItems();
          btn.querySelector('.btn__inner').innerHTML = btnText;
          scrollToTop()
        }
      }
    });

    hideItems();

    if (el.dataset.more === 'pc') {
      if (window.innerWidth < 899) {
        showAllItems();
      }
    }
  });
}